import React, { useEffect, useState } from "react";
import "./Stepper.css";
import { TiTick } from "react-icons/ti";
import useIsMobile from "Hooks/useIsMobile";
const Stepper = ({
  currentStep,
  setContentStep,
  contentStep,
  caseDetails
}) => {
  const stepsLg = ["Create", "Requests", "Approved", "Conflict check", "Request to close", "Closed"];
  const stepsMb = ["Create", "Requests", "Approved", "Conflict check", "Close Req", "Closed"]
  const [steps, setSteps] = useState(stepsLg);
  const hoverInfoArr =
  ["Your case is now listed for Attorneys to view. Wait for requests to come in.", "Review these attorneys to approve them to view the complete case information", "The attorneys will check for your name and adverse party names to makes sure there is no conflict on their end", "Attorneys cleared conflicts for your case and now viewing your complete case information", "Attorney Requested to close the case", "Case is closed"];
  const [stepsAnimate, setStepsAnimate] = useState(currentStep);
  const [showArrow, setShowArrow] = useState(true);
  const reqCount=caseDetails?.userCase?.requested?.length;
  const approvedCount=caseDetails?.userCase?.approved?.length;
  const noConflictCount=caseDetails?.userCase?.noConflict?.length;
  const [hoverInfo, setHoverInfo] = useState(null);

  useEffect(() => {
        setStepsAnimate(currentStep);
        setShowArrow(true);

  },[currentStep])
  useEffect(() => {
    if (window.innerWidth < 1024) {
      setSteps(stepsMb);
    } else {
      setSteps(stepsLg);
    }
  }, []);
  const isMobile = useIsMobile();
  if (isMobile) {
    // Mobile: one status line + a 6-part progress bar instead of six tiny dots,
    // and pills (only for stages already reached) to switch the list below.
    const labels = ["Created", "Requests", "Approved", "Conflict check", "Close request", "Closed"];
    const counts = { 2: reqCount, 3: approvedCount, 4: noConflictCount };
    const reached = [];
    for (let s = 2; s <= Math.min(currentStep, 6); s++) reached.push(s);
    return (
      <div className="w-full font-plexsans" style={{ padding: '4px 16px 14px' }}>
        <div className="flex items-baseline justify-between" style={{ marginBottom: '8px', gap: '10px' }}>
          <span style={{ font: "600 14px/1.2 'IBM Plex Sans',sans-serif", color: '#14213d' }}>{labels[Math.max(currentStep, 1) - 1]}</span>
          <span style={{ font: "500 11.5px/1 'IBM Plex Sans',sans-serif", color: 'rgba(20,33,61,.5)' }}>Step {Math.max(currentStep, 1)} of 6</span>
        </div>
        <div className="flex" style={{ gap: '4px' }}>
          {labels.map((l, i) => (
            <div key={l} style={{ flex: 1, height: '4px', borderRadius: '2px', background: i + 1 <= currentStep ? '#8a6231' : 'rgba(20,33,61,.12)' }} />
          ))}
        </div>
        {reached.length > 1 &&
          <div className="flex hide-vertical-scrollbar" style={{ gap: '8px', marginTop: '12px', overflowX: 'auto' }}>
            {reached.map((s) => {
              const sel = contentStep === s;
              return (
                <span key={s} onClick={() => setContentStep(s)} style={{ flex: 'none', display: 'flex', alignItems: 'center', gap: '6px', font: "500 12.5px/1 'IBM Plex Sans',sans-serif", padding: '8px 12px', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', color: sel ? '#fffdf8' : '#14213d', background: sel ? '#14213d' : '#fff', border: `1px solid ${sel ? '#14213d' : 'rgba(20,33,61,.2)'}` }}>
                  {labels[s - 1]}
                  {counts[s] ? <span style={{ font: "600 11px/1 'IBM Plex Sans',sans-serif", opacity: .75 }}>{counts[s]}</span> : null}
                </span>
              );
            })}
          </div>}
      </div>
    );
  }
  return (
    <>
      <div className="flex justify-center w-full pb-4 font-plexsans">
        {steps?.map((step, i) => (
          <div
            key={i}
            onMouseEnter={() => setHoverInfo(i)

            }
            onMouseLeave={() => setHoverInfo(null)}
            onClick={()=> (i < currentStep) ? setContentStep(i+1) : ''}
            className={`step-item ${stepsAnimate === i + 1 && "active"} ${
              (i + 1 <= stepsAnimate) && "complete"
            } `}
          >
              <div className="step cursor-pointer">
                {i + 1 <= stepsAnimate ?
                <TiTick size={14} className="hidden lg:block text-white" /> : null
                }
                {reqCount !== undefined && reqCount !== 0 && i === 1 &&
                <span className="absolute -top-1 -right-1 flex items-center justify-center text-[9px] lg:text-[10px] font-semibold text-white rounded-full w-[14px] h-[14px] lg:w-[16px] lg:h-[16px] bg-[#b3451f]">{reqCount}</span>
                }
                {approvedCount !== undefined && approvedCount !== 0 && i === 2 &&
                <span className="absolute -top-1 -right-1 flex items-center justify-center text-[9px] lg:text-[10px] font-semibold text-white rounded-full w-[14px] h-[14px] lg:w-[16px] lg:h-[16px] bg-tan">{approvedCount}</span>
                }
                {noConflictCount !== undefined && noConflictCount !== 0 && i === 3 &&
                <span className="absolute -top-1 -right-1 flex items-center justify-center text-[9px] lg:text-[10px] font-semibold text-white rounded-full w-[14px] h-[14px] lg:w-[16px] lg:h-[16px] bg-tan">{noConflictCount}</span>
                }
              </div>
              <p className="text-[rgba(20,33,61,.55)] lg:text-[14px] text-[10px] mt-2 truncate relative">
                {step}
                {
                  hoverInfo === i &&
                  <div className="absolute z-20 text-xs border border-[rgba(20,33,61,.12)] bg-white px-4 text-navy p-2 rounded-md shadow-md top-12 w-[300px] left-1/2 transform -translate-x-1/2">
                    {hoverInfoArr[i]}
                  </div>
                }
              </p>
              {contentStep - 1 === i && contentStep !== 1 && showArrow ?
              <div className="absolute border-[17px] border-t-0 border-r-transparent border-l-transparent border-b-white h-0 w-0 -bottom-5"></div> : ''}
          </div>
        ))}
      </div>
    </>
  );
};

export default Stepper;
